import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterLink, RouterModule, RouterOutlet } from '@angular/router';
import { FuseFullscreenComponent } from '@fuse/components/fullscreen';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import {
    FuseHorizontalNavigationComponent,
    FuseNavigationService,
    FuseVerticalNavigationComponent,
} from '@fuse/components/navigation';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { Navigation } from 'app/core/navigation/navigation.types';
import { LanguagesComponent } from 'app/layout/common/languages/languages.component';
import { UserComponent } from 'app/layout/common/user/user.component';
import { Subject, Subscription, takeUntil } from 'rxjs';
import Gleap from 'gleap';
import { DarkLightModule } from 'app/layout/common/dark-light/dark-light.module';
import { BundyModule } from 'app/layout/common/bundy/bundy.module';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SessionTimeoutComponent } from 'app/core/session-timeout/session-timeout.component';
import { SuccessMessage } from 'app/model/message.constant';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { CoreService } from 'app/services/coreService/coreService.service';
import { MasterService } from 'app/services/masterService/master.service';
import { IdleDetectionService } from 'app/services/idle/idle-detection.service';
import { AuthService } from 'app/services/authService/auth.service';
import { DarkLightComponent } from 'app/layout/common/dark-light/dark-light.component';
import { BundyComponent } from 'app/layout/common/bundy/bundy.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'modern-layout',
    templateUrl: './modern.component.html',
        styleUrls: ['./modern.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
    FuseLoadingBarComponent,
    FuseVerticalNavigationComponent,
    FuseHorizontalNavigationComponent,
    MatButtonModule,
    MatIconModule,
    FuseFullscreenComponent,
    UserComponent,
    RouterOutlet,
    BundyComponent,
    LanguagesComponent,
    RouterLink,
    RouterModule,
    DarkLightComponent,
],
})
export class ModernLayoutComponent implements OnInit, OnDestroy {
    isScreenSmall: boolean = false;
    navigation: Navigation;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    bundy = false
    companyname = sessionStorage.getItem('cn')
    device = sessionStorage.getItem('device')
    route = sessionStorage.getItem('route')
    is = (sessionStorage.getItem('is') == "true")
    isIsView = sessionStorage.getItem('currentView') !== 'supervisor';
    idlecountdown = 120
    idleState = "NOT_STARTED";
    countdown?: number = null;
    lastPing?: Date = null;
    dialogRef: MatDialogRef<SessionTimeoutComponent, any>;
    onIdleStartSubscription: Subscription
    onIdleEndSubscription: Subscription
    onTimeoutSubscription: Subscription
    onTimeoutWarningSubscription: Subscription
    onPingSubscription: Subscription
    successMessage = Object.assign({},SuccessMessage)

    /**
     * Constructor
     */
    constructor(
        private _router: Router,
        private _navigationService: NavigationService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private idle: IdleDetectionService,
        private cd: ChangeDetectorRef,
        public dialog: MatDialog,
        private core: CoreService,
        private message: FuseConfirmationService,
        private auth: AuthService,
    ) {
        this.usetifulRun();
        this.idleRun();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to navigation data
        this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: Navigation) => {
                this.navigation = navigation;
            });

        this.bundy = (sessionStorage.getItem('bundy')=="true")

        this.startTour()
        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({ matchingAliases }) => {
                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
            });

        // Initialize Idle after the component is stable to avoid Zone errors
        // Defer to next tick to prevent ExpressionChangedAfterItHasBeenCheckedError
        setTimeout(() => this.reset(), 0);
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();

        if (this.onIdleStartSubscription) {
            // console.log("ngOnDestroy")
            this.onIdleStartSubscription.unsubscribe();
            this.onIdleEndSubscription.unsubscribe();
            this.onTimeoutSubscription.unsubscribe();
            this.onTimeoutWarningSubscription.unsubscribe();
            this.onPingSubscription.unsubscribe();
        }
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void {
        // Get the navigation
        const navigation =
            this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(
                name
            );

        if (navigation) {
            // Toggle the opened status
            navigation.toggle();
        }
    }

    switchPage() {

        const nextView = this.isIsView
            ? 'supervisor'
            : 'employee';

        sessionStorage.setItem('currentView', nextView);

        this.isIsView = !this.isIsView;

        this._router.navigate([
            nextView === 'supervisor'
                ? '/dashboard/supervisor'
                : '/dashboard/employee'
        ]);
    }

    usetifulRun() {
        if (this.auth.isAuthenticated()) {
            var element = document.querySelector("#usetifulScript")
            if (!element) {
                // element.remove();
                var supervisor = (sessionStorage.getItem('is') == 'true')
                window["usetifulTags"] = {
                    userId: localStorage.getItem("series") + "_1" + sessionStorage.getItem("u"),
                    company: localStorage.getItem("series"),
                    role: supervisor ? "Supervisor" : "Basic",
                    display_name: localStorage.getItem("dn"),
                    reportTag: sessionStorage.getItem("reportTag") == "true",
                    language : sessionStorage.getItem("activeLang")
                };

                var a = document.getElementsByTagName('head')[0];
                var r = document.createElement('script');
                r.async = true;
                r.src = "https://www.usetiful.com/dist/usetiful.js";
                r.setAttribute('id', 'usetifulScript');
                r.dataset.token = "fea529879f55a374d77cd3ff88898b9b";
                a.appendChild(r);
            }
        }
    }

    startTour() {
        var supervisor = (sessionStorage.getItem('is') == 'true')
        var userId = sessionStorage.getItem("se") + "_" + sessionStorage.getItem("u");
        var obj = {
            name: sessionStorage.getItem("dn"),
            email: sessionStorage.getItem("email"),
            phone: "",
            companyId: sessionStorage.getItem("se"),
            companyName: sessionStorage.getItem("cc"),
            customData: {
                companyCode: sessionStorage.getItem("cc"),
                companyName: sessionStorage.getItem("cn"),
                seriesCode: sessionStorage.getItem("se"),
                gleapTour: supervisor ? "Supervisor" : "Basic",
                usetifulTour: localStorage.getItem('usetiful'),
                reportTag: sessionStorage.getItem("reportTag") == "true",
                language : sessionStorage.getItem("activeLang"),
            },
        }

        Gleap.identify(userId, obj, "GENERATED_USER_HASH");
        Gleap.updateContact(obj);
        Gleap.trackEvent("User signed in", { userId: userId, name: obj.name, date: new Date() });
        Gleap.startProductTour("660a4219a844991918862ade");

    }

    idleRun() {
        // set idle parameters
        this.idle.setIdle(3600); // how long can they be inactive before considered idle, in seconds 900
        this.idle.setTimeout(this.idlecountdown); // how long can they be idle before considered timed out, in seconds 120
        // this.idle.setKeepaliveInterval(15); // keepalive ping interval in seconds

        // do something when the user becomes idle
        this.onIdleStartSubscription = this.idle.onIdleStart.subscribe(() => {
            this.idleState = "IDLE";
            // console.log(this.idleState, this.countdown)
            this.idStart();
        });
        // do something when the user is no longer idle
        this.onIdleEndSubscription = this.idle.onIdleEnd.subscribe(() => {
            this.idleState = "NOT_IDLE";
            // console.log(`${this.idleState} ${new Date()}`)
            this.countdown = null;
            this.cd.markForCheck(); // trigger change detection in zoneless mode
        });
        // do something when the user has timed out
        this.onTimeoutSubscription = this.idle.onTimeout.subscribe(() => {
            this.idleState = "TIMED_OUT";
            // console.log(this.idleState)
            this.dialogRef.close();
            this.logout(false)
        });
        // do something as the timeout countdown does its thing
        this.onTimeoutWarningSubscription = this.idle.onTimeoutWarning.subscribe(seconds => {
            this.countdown = seconds;
            this.idleState = 'You have been idle for 1 Hour. You will time out in ' + seconds + ' seconds!'
            this.core.updateIdleState(this.idleState)
            // console.log(this.idleState)
        });

        // keepalive ping handler
        this.onPingSubscription = this.idle.onKeepalive.subscribe(() => {
            this.lastPing = new Date();
            // console.log("lastPing",this.lastPing)
        });

        // Start watching for idle state
        this.idle.watch();
    }

    idStart() {
        if (this.dialogRef) {
            this.dialogRef.close()
        }

        var byPassIdle = (sessionStorage.getItem("byPassIdle") == "true")
        if (byPassIdle) {
            this.reset();
            return
        }

        this.dialogRef = this.dialog.open(SessionTimeoutComponent, {
            panelClass: 'app-dialog',
            disableClose: true
        })

        this.dialogRef.componentInstance.btnLogout.subscribe(() => {
            this.logout(true);
        });

        this.dialogRef.componentInstance.btnStay.subscribe(() => {
            this.dialogRef.close()
            this.reset();
        });
    }

    logout(manual) {
        this.idle.stop()
        this.dialogRef.close()
        sessionStorage.clear();
        this.successMessage.title = "Logged out due to inactivity"
        this.successMessage.message = "You have been logged out due to inactivity for 1 Hour!"
        this.successMessage.actions.confirm.label = "Ok"
        if (!manual) {
            this._router.navigate(['/'])
            this.message.open(this.successMessage);
        } else {
            this._router.navigate(['/']);
        }
    }

    reset() {
        // we'll call this method when we want to start/reset the idle process
        // reset any component state and be sure to call idle.watch()
        this.idle.watch();
        this.idleState = "NOT_IDLE";
        this.countdown = null;
        this.lastPing = null;

        this.idleState = 'You have been idle for 1 Hour. You will time out in ' + this.idlecountdown + ' seconds!' //reset countdown message
        this.core.updateIdleState(this.idleState)
    }
}
